module.exports = __webpack_public_path__ + "static/media/logo.196af16a.svg";